<template>
<div class="chapter">
<div class="inner_page">
<h1 class="toc-title"><span>Contents</span></h1>
<p class="toc-chapter" id="toc-ad-card"><span href="#/adcard" title="Link target outside of Sample">By the same author</span></p>
<p class="toc-chapter" id="toc-copyright"><span href="#/copyright" title="Link target outside of Sample">Copyright</span></p>
<p class="toc-chapter"><a href="#/dedication">Dedication</a></p>
<p class="toc-chapter1" id="toc-part001"><strong><a href="#/part001">Part One</a></strong></p>
<p class="toc-chapter" id="toc-chapter001"><a href="#/chapter001">Chapter One</a></p>
<p class="toc-chapter" id="toc-chapter002"><span href="#/chapter002" title="Link target outside of Sample">Chapter Two</span></p>
<p class="toc-chapter" id="toc-chapter003"><span href="#/chapter003" title="Link target outside of Sample">Chapter Three</span></p>
<p class="toc-chapter1" id="toc-part002"><strong><span href="#/part002" title="Link target outside of Sample">Part Two</span></strong></p>
<p class="toc-chapter" id="toc-chapter004"><span href="#/chapter004" title="Link target outside of Sample">Chapter One</span></p>
<p class="toc-chapter" id="toc-chapter005"><span href="#/chapter005" title="Link target outside of Sample">Chapter Two</span></p>
<p class="toc-chapter" id="toc-chapter006"><span href="#/chapter006" title="Link target outside of Sample">Chapter Three</span></p>
<p class="toc-chapter1" id="toc-part003"><strong><span href="#/part003" title="Link target outside of Sample">Part Three</span></strong></p>
<p class="toc-chapter" id="toc-chapter007"><span href="#/chapter007" title="Link target outside of Sample">Chapter One</span></p>
<p class="toc-chapter" id="toc-chapter008"><span href="#/chapter008" title="Link target outside of Sample">Chapter Two</span></p>
<p class="toc-chapter" id="toc-chapter009"><span href="#/chapter009" title="Link target outside of Sample">Chapter Three</span></p>
<p class="toc-chapter" id="toc-chapter010"><span href="#/chapter010" title="Link target outside of Sample">Chapter Four</span></p>
<p class="toc-chapter" id="toc-chapter011"><span href="#/chapter011" title="Link target outside of Sample">Chapter Five</span></p>
<p class="toc-chapter1" id="toc-part004"><strong><span href="#/part004" title="Link target outside of Sample">Part Four</span></strong></p>
<p class="toc-chapter" id="toc-chapter012"><span href="#/chapter012" title="Link target outside of Sample">Chapter One</span></p>
<p class="toc-chapter" id="toc-chapter013"><span href="#/chapter013" title="Link target outside of Sample">Chapter Two</span></p>
<p class="toc-chapter" id="toc-chapter014"><span href="#/chapter014" title="Link target outside of Sample">Chapter Three</span></p>
<p class="toc-chapter" id="toc-chapter015"><span href="#/chapter015" title="Link target outside of Sample">Chapter Four</span></p>
<p class="toc-chapter" id="toc-chapter016"><span href="#/chapter016" title="Link target outside of Sample">Chapter Five</span></p>
<p class="toc-chapter" id="toc-chapter017"><span href="#/chapter017" title="Link target outside of Sample">Chapter Six</span></p>
<p class="toc-chapter" id="toc-chapter018"><span href="#/chapter018" title="Link target outside of Sample">Chapter Seven</span></p>
<p class="toc-chapter" id="toc-chapter019"><span href="#/chapter019" title="Link target outside of Sample">Chapter Eight</span></p>
<p class="toc-chapter1"><span href="#/personblurb" title="Link target outside of Sample">About the Author</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// toc.vue?0f9fe0be